import {IRouterStateUrl} from '../stores/router/router.store';
import {IGridStatus}     from '../ap-interface/interfaces/ap-grid-status.interface';
import IGuid = System.IGuid;
import IDriver = Data.DocuContext.Driver.IDriver;
import IInstrument = Data.DocuContext.Instrument.IInstrument;
import IMachine = Data.DocuContext.Machine.IMachine;
import IExportTarget = Data.Common.IExportTarget;
import IFieldBase = Data.FieldManagement.IFieldBase;
import TaskManagementModule = Data.TaskManagement.TaskManagementModule;
import ITaskManagementPlanSummary = Data.TaskManagement.ITaskManagementPlanSummary;
import ITaskManagementPlanBook = Data.TaskManagement.ITaskManagementPlanBook;

export interface ITaskManagementPlanSummaryGridData {
  Id: IGuid;
  Status: IGridStatus;
  Module: TaskManagementModule;
  ModuleText: string;
  ApplicationModeText: string;
  OperationModeText: string;
  ElementName: string;
  ProductName: string;
  AreaHaSum: number;
  UserApplRate: number;
  UserApplSum: number;
  ProductUnit: string;
  ApplUnitPerHa: string;
  ProductUnitPerHa: string;
  AlreadyExported: string;
  ApplDate: Date;
  FieldsTooltip: string;
  Note: string;
  SourceItem: ITaskManagementPlanSummary;
}

export interface ITaskManagementPlanBookGridData {
  Id: IGuid;
  Status: IGridStatus;
  Field: IFieldBase;
  ModuleText: string;
  ApplicationModeText: string;
  OperationModeText: string;
  ElementName: string;
  ProductName: string;
  ProductUnitPerHa: string;
  ProductTooltip: string;
  CropName: string;
  AreaHa: number;
  ApplRate: number;
  ApplMin: number;
  ApplMax: number;
  ApplSum: number;
  ApplDate: Date;
  ExportedAt: Date;
  ExportTargetText: string;
  ExportDriver: IDriver;
  ExportInstrument: IInstrument;
  ExportMachine: IMachine;
  SelectedExportTargetObject: IExportTarget;
  SourceItem: ITaskManagementPlanBook;
}

export class TaskManagementWizardOpenConfig {
  PlanSummary: ITaskManagementPlanSummaryGridData;
  Type: TaskManagementWizardOpenConfigType;
  RouterData: IRouterStateUrl;
}

export enum TaskManagementWizardOpenConfigType {
  Export = 0,
  Show = 1
}

export enum TaskManagementAction {
  Booking = '0',
  Edit = '1'
}
